module.exports = __webpack_public_path__ + "img/744.d189da1f.jpg";